import {
  RequestModel,
  requestModel,
} from '@/app/request/RequestModel';
import { useBitrixStore } from '@/shared/store/useBitrixStore';
import { useUserStore } from '@/shared/store/useUserStore';

export function bitrixKeepSyncPartnerId(updateRequest: RequestModel) {
  const userStore = useUserStore();
  const bitrixStore = useBitrixStore();
  const { partnerId } = userStore;
  const bitrixPartnerId = bitrixStore.partnerId;

  if (partnerId && partnerId !== bitrixPartnerId) {
    updateRequest = requestModel(updateRequest, {
      body: {
        ...updateRequest.body,
        partner_id: partnerId,
      },
    });
    bitrixStore.setPartnerId(partnerId);
  }

  return updateRequest;
}
